// import React, { useState, useEffect } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import NavbarForOnboardingForm from "./onboarding/NavbarForOnbardingForm";
// import { useLoading } from "./LoadingContext";

// function EditForm() {
//   const navigate = useNavigate();
//   const { id } = useParams(); // Get the job id from the URL parameters

//   const [jobData, setJobData] = useState({
//     role: "",
//     description: "",
//     mandatory_skills: "",
//     optional_skills: "",
//     total_experience: "",
//     relevant_experience: "",
//     education: "",
//     location: "",
//     offered_CTC: "",
//   });

//   const { loading, setLoading } = useLoading();
//   const [error, setError] = useState(null);

//   // Unified handleChange to manage all form input fields
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setJobData((prevJobData) => ({
//       ...prevJobData,
//       [name]: value !== null ? value : "", // Ensure controlled input by using an empty string instead of null
//     }));
//   };

//   const handleEdit = (event) => {
//     event.preventDefault();

//     axios
//       .put(
//         `${process.env.REACT_APP_API_BASE_URL}/api/job-descriptions/${id}/`,
//         jobData
//       )
//       .then((response) => {
//         console.log(response.data);
//         navigate("/jd_dashboard");
//       })
//       .catch((error) => {
//         if (
//           error.response &&
//           error.response.data &&
//           error.response.data.message
//         ) {
//           alert(error.response.data.message); // Show the backend error message as an alert
//         } else {
//           console.error(error);
//         }
//       });
//   };

//   // Fetch job data based on the id from your API
//   useEffect(() => {
//     setLoading(true);
//     axios
//       .get(`${process.env.REACT_APP_API_BASE_URL}/api/job-descriptions/${id}/`)
//       .then((response) => {
//         const data = response.data;
//         // Ensure that all fields have values, using empty strings where necessary
//         setJobData({
//           role: data.role || "",
//           description: data.description || "",
//           mandatory_skills: data.mandatory_skills || "",
//           optional_skills: data.optional_skills || "",
//           total_experience: data.total_experience || "",
//           relevant_experience: data.relevant_experience || "",
//           education: data.education || "",
//           location: data.location || "",
//           offered_CTC: data.offered_CTC || "",
//         });
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error(error);
//         if (
//           error.response &&
//           error.response.data &&
//           error.response.data.message
//         ) {
//           alert(error.response.data.message); // Show the backend error message as an alert
//         } else {
//           console.error(error);
//           alert("An unexpected error occurred. Please try again.");
//         }
//         setError(error);
//         setLoading(false);
//       });
//   }, [id]);

//   if (loading) {
//     return (
//       <div
//         className="container d-flex justify-content-center align-items-center"
//         style={{ height: "100vh" }}
//       >
//         <div>
//           <div
//             className="spinner-border text-dark"
//             role="status"
//             style={{ width: "3rem", height: "3rem" }}
//           >
//             <span className="visually-hidden">Loading...</span>
//           </div>
//         </div>
//         <h3 className="text-center text-dark">&nbsp;Data is Fetching.... </h3>
//       </div>
//     );
//   }

//   if (error) {
//     return <div>Error: {error.message}</div>;
//   }

//   return (
//     <>
//       <NavbarForOnboardingForm />
//       <div className="container py-5">
//         <div className="row d-flex justify-content-center align-items-center h-100">
//           <div className="col-10 col-md-8 col-lg-6 col-xl-5 log">
//             <div className="card border border-dark bg-transparent text-white">
//               <div
//                 className="card-header border-dark text-white"
//                 style={{ background: "#008cba" }}
//               >
//                 <h4 className="text-center font_header">
//                   Update JD Configurator Form
//                 </h4>
//               </div>
//               <div className="card-body">
//                 <form onSubmit={handleEdit} className="text-dark">
//                   <div className="row">
//                     <div className="col-md-6 mb-2">
//                       <label className="form-label" htmlFor="role">
//                         Role
//                       </label>
//                       <input
//                         type="text"
//                         id="role"
//                         name="role"
//                         className="form-control border-dark text-dark"
//                         placeholder="Role"
//                         value={jobData.role}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6 mb-2">
//                       <label className="form-label" htmlFor="description">
//                         Description
//                       </label>
//                       <input
//                         type="text"
//                         id="description"
//                         className="form-control border-dark text-dark"
//                         placeholder="Description"
//                         name="description"
//                         value={jobData.description}
//                         onChange={handleChange}
//                       />
//                     </div>
//                   </div>
//                   <div className="row">
//                     <div className="col-md-6 mb-2">
//                       <label className="form-label" htmlFor="mandatory_skills">
//                         Mandatory Skills
//                       </label>
//                       <input
//                         type="text"
//                         id="mandatory_skills"
//                         className="form-control border-dark text-dark "
//                         name="mandatory_skills"
//                         value={jobData.mandatory_skills}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6 mb-2">
//                       <label htmlFor="optional_skills" className="form-label">
//                         Optional Skills
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control border-dark text-dark"
//                         id="optional_skills"
//                         name="optional_skills"
//                         value={jobData.optional_skills}
//                         onChange={handleChange}
//                       />
//                     </div>
//                   </div>
//                   <div className="row">
//                     <div className="col-md-6 mb-2">
//                       <label htmlFor="total_experience" className="form-label">
//                         Total Experience
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control border-dark text-dark"
//                         id="total_experience"
//                         name="total_experience"
//                         value={jobData.total_experience}
//                         onChange={handleChange}
//                       />
//                     </div>

//                     <div className="col-md-6 mb-2">
//                       <label
//                         htmlFor="relevant_experience"
//                         className="form-label"
//                       >
//                         Relevant Experience
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control border-dark text-dark"
//                         id="relevant_experience"
//                         name="relevant_experience"
//                         value={jobData.relevant_experience}
//                         onChange={handleChange}
//                       />
//                     </div>
//                   </div>
//                   <div className="row">
//                     <div className="col-md-6 mb-2">
//                       <label htmlFor="education" className="form-label">
//                         Education
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control border-dark text-dark"
//                         id="education"
//                         name="education"
//                         value={jobData.education}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6 mb-2">
//                       <label className="form-label" htmlFor="ectc">
//                         Offered CTC
//                       </label>
//                       <input
//                         name="offered_CTC"
//                         type="text"
//                         id="ectc"
//                         className="form-control border-dark text-dark"
//                         value={jobData.offered_CTC}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="mb-2">
//                       <label htmlFor="location" className="form-label">
//                         Location
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control border-dark text-dark"
//                         id="location"
//                         name="location"
//                         value={jobData.location}
//                         onChange={handleChange}
//                       />
//                     </div>
//                   </div>
//                   <div className="text-center py-2">
//                     <button
//                       type="submit"
//                       className="btn btn-outline-info me-2"
//                       onClick={handleEdit}
//                     >
//                       Submit
//                     </button>
//                     <button
//                       className="btn btn-outline-danger"
//                       type="button"
//                       onClick={() => navigate("/jd_dashboard")}
//                     >
//                       Close
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default EditForm;

import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import NavbarForOnboardingForm from "./onboarding/NavbarForOnbardingForm";
import { useLoading } from "./LoadingContext";

function EditForm() {
  const navigate = useNavigate();
  const { id } = useParams(); // Get JD ID from URL
  const { loading, setLoading } = useLoading();
  const [error, setError] = useState(null);

  // State for JD Fields
  const [jobData, setJobData] = useState({
    role: "",
    description: "",
    mandatory_skills: "",
    optional_skills: "",
    total_experience: "",
    relevant_experience: "",
    education: "",
    location: "",
    offered_CTC: "",
  });

  // State for JD Weightages
  const [weightage, setWeightage] = useState({
    mandatory_skills_weight: 40,
    relevant_experience_weight: 30,
    education_weight: 15,
    location_weight: 10,
    optional_skills_weight: 5,
  });

  // Handle input changes for JD fields
  const handleChange = (e) => {
    const { name, value } = e.target;
    setJobData((prev) => ({
      ...prev,
      [name]: value !== null ? value : "",
    }));
  };

  // Handle input changes for weightage fields
  const handleWeightageChange = (e) => {
    const { name, value } = e.target;
    setWeightage((prev) => ({
      ...prev,
      [name]: value !== null ? Number(value) : 0,
    }));
  };

  // Fetch JD Data on Component Mount
  useEffect(() => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/job-descriptions/${id}/`)
      .then((response) => {
        const data = response.data;
        setJobData({
          role: data.role || "",
          description: data.description || "",
          mandatory_skills: data.mandatory_skills || "",
          optional_skills: data.optional_skills || "",
          total_experience: data.total_experience || "",
          relevant_experience: data.relevant_experience || "",
          education: data.education || "",
          location: data.location || "",
          offered_CTC: data.offered_CTC || "",
        });

        // Load Weightages from API
        setWeightage({
          mandatory_skills_weight: data.mandatory_skills_weight || 40,
          relevant_experience_weight: data.relevant_experience_weight || 30,
          education_weight: data.education_weight || 15,
          location_weight: data.location_weight || 10,
          optional_skills_weight: data.optional_skills_weight || 5,
        });

        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        alert("Error fetching JD data. Please try again.");
        setError(error);
        setLoading(false);
      });
  }, [id]);

  // Submit updated JD data
  const handleEdit = (event) => {
    event.preventDefault();

    // Validate that total weightage equals 100%
    const totalWeightage =
      weightage.mandatory_skills_weight +
      weightage.relevant_experience_weight +
      weightage.education_weight +
      weightage.location_weight +
      weightage.optional_skills_weight;

    if (totalWeightage !== 100) {
      alert("Total weightage must be exactly 100%.");
      return;
    }

    const updatedData = {
      ...jobData,
      ...weightage, // Merge weightages with job data
    };

    axios
      .put(
        `${process.env.REACT_APP_API_BASE_URL}/api/job-descriptions/${id}/`,
        updatedData
      )
      .then((response) => {
        console.log(response.data);
        navigate("/jd_dashboard");
      })
      .catch((error) => {
        console.error(error);
        alert("Error updating JD. Please try again.");
      });
  };

  if (loading) {
    return (
      <div
        className="container d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div
          className="spinner-border text-dark"
          role="status"
          style={{ width: "3rem", height: "3rem" }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>
        <h3 className="text-center text-dark">Fetching JD Data...</h3>
      </div>
    );
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <>
      <NavbarForOnboardingForm />
      <div className="container py-5">
        <div className="row d-flex justify-content-center align-items-center h-100">
          <div className="col-10 col-md-8 col-lg-6 col-xl-5 log">
            <div className="card border border-dark bg-transparent text-white">
              <div
                className="card-header border-dark text-white"
                style={{ background: "#008cba" }}
              >
                <h4 className="text-center font_header">Update JD</h4>
              </div>
              <div className="card-body">
                <form onSubmit={handleEdit} className="text-dark">
                  {/* Role & Description */}
                  <div className="row">
                    <div className="col-md-6 mb-2">
                      <label className="form-label">Role</label>
                      <input
                        type="text"
                        className="form-control border-dark"
                        name="role"
                        value={jobData.role}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6 mb-2">
                      <label className="form-label">Description</label>
                      <input
                        type="text"
                        className="form-control border-dark"
                        name="description"
                        value={jobData.description}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  {/* Total Experience & Offered CTC */}
                  <div className="row">
                    <div className="col-md-6 mb-2">
                      <label className="form-label">Total Experience</label>
                      <input
                        type="text"
                        className="form-control border-dark"
                        name="total_experience"
                        value={jobData.total_experience}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6 mb-2">
                      <label className="form-label">Offered CTC</label>
                      <input
                        type="text"
                        className="form-control border-dark"
                        name="offered_CTC"
                        value={jobData.offered_CTC}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  {/* Rest of the Fields & Weightages */}
                  {[
                    "mandatory_skills",
                    "optional_skills",
                    "relevant_experience",
                    "education",
                    "location",
                  ].map((field) => (
                    <div className="row" key={field}>
                      <div className="col-md-6 mb-2">
                        {/* <label className="form-label">
                          {field.replace("_", " ").toUpperCase}
                        </label> */}
                        <label className="form-label">
                          {field
                            .replace(/_/g, " ") // Replace underscores with spaces
                            .toLowerCase() // Convert the whole string to lowercase
                            .replace(/\b\w/g, (char) =>
                              char.toUpperCase()
                            )}{" "}
                          {/* Capitalize first letter of each word */}
                        </label>

                        <input
                          type="text"
                          className="form-control border-dark"
                          name={field}
                          value={jobData[field]}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-md-6 mb-2">
                        <label className="form-label">Weightage (%)</label>
                        <input
                          type="number"
                          className="form-control border-dark"
                          name={`${field}_weight`}
                          value={weightage[`${field}_weight`]}
                          onChange={handleWeightageChange}
                        />
                      </div>
                    </div>
                  ))}

                  <div className="text-center py-2">
                    <button type="submit" className="btn btn-outline-info me-2">
                      Update
                    </button>
                    <button
                      className="btn btn-outline-danger"
                      type="button"
                      onClick={() => navigate("/jd_dashboard")}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditForm;
